import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import strings from 'strings'
import styles from './SignaturePreview.module.scss'

const S = strings.PROFILE_SIGNATURE

// Rosette edge of the seal, the same shape the credit memo PDF prints.
const SIZE = 88
const CENTER = SIZE / 2
const EDGE = Array.from({ length: 72 }, (_, i) => {
  const radius = i % 2 === 0 ? 43.5 : 40.5
  const angle = (Math.PI * i) / 36 - Math.PI / 2
  return `${(CENTER + radius * Math.cos(angle)).toFixed(2)},${(CENTER + radius * Math.sin(angle)).toFixed(2)}`
}).join(' ')

const Seal = ({ date }) => (
  <div className={styles.seal} aria-hidden="true">
    <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
      <polygon points={EDGE} className={styles.sealFill} strokeWidth={1} />
      <circle cx={CENTER} cy={CENTER} r={35} fill="none" className={styles.sealStroke} strokeWidth={1.25} />
      <circle cx={CENTER} cy={CENTER} r={32} fill="none" className={styles.sealStroke} strokeWidth={0.5} strokeDasharray="1.5,1.5" />
      <path d="M37 28l5 5 9-9" fill="none" className={styles.sealStroke} strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <div className={styles.sealText}>
      <span className={styles.sealTitle}>APPROVED</span>
      <span className={styles.sealDate}>{date}</span>
      <span className={styles.sealBrand}>ROX</span>
    </div>
  </div>
)

/** The approval block of a signed credit memo, drawn in HTML so the approver can see it before signing. */
const SignaturePreview = ({ name, email, mark, stamp, drawnImage, compact }) => {
  const date = moment().format('MMM D, YYYY').toUpperCase()
  const signer = (
    <div className={styles.signer}>
      {mark === 'DRAWN' && drawnImage
        ? <img src={drawnImage} alt="" className={styles.drawn} />
        : <div className={styles.typed}>{name}</div>}
      <div className={styles.line} />
      <div className={styles.name}>{name}</div>
      <div className={styles.meta}>{S.PREVIEW_ROLE}</div>
      {email && <div className={styles.meta}>{email}</div>}
    </div>
  )

  return (
    <div className={`${styles.paper} ${compact ? styles.compact : ''}`}>
      {stamp === 'STAMP' ? (
        <div className={styles.stamp}>
          <div className={styles.stampHeader}>
            <span>APPROVED</span>
            <span>{date}</span>
          </div>
          {signer}
        </div>
      ) : (
        <div className={styles.row}>
          {signer}
          {stamp !== 'PLAIN' && <Seal date={date} />}
        </div>
      )}
    </div>
  )
}

SignaturePreview.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  mark: PropTypes.oneOf(['TYPED', 'DRAWN']),
  stamp: PropTypes.oneOf(['PLAIN', 'STAMP', 'SEAL']),
  drawnImage: PropTypes.string,
  compact: PropTypes.bool
}

export default SignaturePreview
